import { FC } from 'react';
import { Image } from 'atoms/Image/Image';

export const ContentImage: FC<{
  src?: string;
  alt?: string;
  width?: number;
  className?: string;
}> = ({ src, alt, width, className }) => {
  const imageUrl = width ? `${src}/m/${width}x0` : src;

  return <Image src={imageUrl} alt={alt} className={className} />;
};
